import styled from 'styled-components';
import { FONT_STACK, FontSize } from '../../../common/styles/constants';

export const SmallText = styled.small`
  ${FONT_STACK}
  font-size: ${FontSize.EXTRA_SMALL};
`;

export const HeadlineText = styled.strong`
  display: block;
  margin-bottom: 8px;
`;
